import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";

import PageLogin from "./pages/Login";
import PageLandingPage from "./pages/LandingPage";
import ColaboradoresPage from "./pages/GestionPage/ColaboradoresPage";
import FormatoEvaluacionPage from "./pages/GestionPage/FormatoEvaluacionPage";
import SeleccionarPanel from "./pages/SeleccionarPanel";
import AdministracionUsuariosExternosPage from "./pages/AdministracionUsuariosExternosPage/ColaboradoresPage";
import AdministracionParametrosPage from "./pages/AdministracionUsuariosExternosPage/ParametrosPage";
import RealizarEvaluacionesPage from "./pages/Evaluaciones/RealizarEvaluacionesPage";
import ReporteEvaluacionesPage from "./pages/ReporteEvaluacionesPage";
import FormatoEvaluacionesPage from "./pages/FormatoEvaluacionPage";
import CategoriasEvaluacionesPage from "./pages/GestionPage/CategoriasEvaluacionesPage";
import RoleRoute from "./RoleRoute";
import RequireAuth from "./components/RequireAuth";

import { Provider } from "react-redux";
import Store from "./pages/redux/store/Store";
import "./App.css";
import "./theme/dashboardUi.css";
import "./theme/pageShell.css";

const PUBLIC_PATHS = ["/", "/seleccionarPanel"];
const APP_BASE = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

const stripBase = (pathname: string) => {
  if (APP_BASE && pathname.startsWith(APP_BASE)) {
    const stripped = pathname.slice(APP_BASE.length) || "/";
    return stripped.startsWith("/") ? stripped : `/${stripped}`;
  }
  return pathname;
};

const AuthHistoryGuard = () => {
  const location = useLocation();
  useEffect(() => {
    const check = () => {
      const hasToken = Boolean(localStorage.getItem("authToken"));
      const path = stripBase(window.location.pathname);
      if (!hasToken && !PUBLIC_PATHS.includes(path)) {
        window.location.replace(`${APP_BASE}/` || "/");
      }
    };
    check();
    const onPageShow = () => check();
    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("popstate", check);
    window.addEventListener("focus", check);
    return () => {
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("popstate", check);
      window.removeEventListener("focus", check);
    };
  }, [location.pathname]);
  return null;
};


function App() {
  return (
    <Provider store={Store}>
      <BrowserRouter basename={process.env.PUBLIC_URL || ""}>
      <AuthHistoryGuard />
        <Routes>
          <Route path="/" element={<PageLogin />} />
          <Route path="/seleccionarPanel" element={<SeleccionarPanel />} />
          <Route path="/home" element={<RequireAuth><PageLandingPage /></RequireAuth>} />
          <Route path="/gestionColaboradores"
            element={<RoleRoute allowedProfiles={["Administrador", "Evaluador"]}><ColaboradoresPage /></RoleRoute>}
          />
          <Route path="/gestionCategoriasEvaluaciones"
            element={<RoleRoute allowedProfiles={["Administrador"]}><CategoriasEvaluacionesPage /></RoleRoute>}
          />
          <Route path="/gestionFormatoEvaluacion"
            element={<RoleRoute allowedProfiles={["Administrador"]}><FormatoEvaluacionPage /></RoleRoute>}
          />
          <Route path="/realizarEvaluaciones"
            element={<RoleRoute allowedProfiles={["Evaluador", "Evaluador Externo"]}><RealizarEvaluacionesPage /></RoleRoute>}
          />
          <Route path="/admonUsuariosExternos"
            element={<RoleRoute allowedProfiles={["Administrador"]}><AdministracionUsuariosExternosPage /></RoleRoute>}
          />
          <Route path="/admonUsuariosParametros"
            element={<RoleRoute allowedProfiles={["Administrador"]}><AdministracionParametrosPage /></RoleRoute>}
          />
          <Route path="/reporteEvaluaciones"
            element={<RoleRoute allowedProfiles={["Administrador", "Evaluador", "Evaluador Externo"]}><ReporteEvaluacionesPage /></RoleRoute>}
          />
          <Route path="/formatoEvaluaciones/:id/:date"
            element={<RoleRoute allowedProfiles={["Administrador", "Evaluador", "Evaluador Externo"]}><FormatoEvaluacionesPage /></RoleRoute>}
          />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;